import {useRef, useState, useEffect} from 'react';

export default ({onInput}) => {
    const inputRef = useRef(),
          [code, setCode] = useState("");

    useEffect(() => {
        onInput(code);
    }, [code]);

    return (
        <div className="form-code-input">
            <input type="tel" ref={inputRef} onInput={e => {
                if(e.target.value.length > 6) {
                    e.target.value = e.target.value.substr(0, 6);
                    e.target.focus();
                }

                setCode(e.target.value);
            }} />
            <div className="code-container" onClick={e => inputRef.current.focus()}>
                <div className={`code ${code.length >= 1 ? 'valued' : ''} ${code.length === 0 ? 'active' : ''}`}>{code[0] || '_'}</div>
                <div className={`code ${code.length >= 2 ? 'valued' : ''} ${code.length === 1 ? 'active' : ''}`}>{code[1] || '_'}</div>
                <div className={`code ${code.length >= 3 ? 'valued' : ''} ${code.length === 2 ? 'active' : ''}`}>{code[2] || '_'}</div>
                <div className="devider"></div>
                <div className={`code ${code.length >= 4 ? 'valued' : ''} ${code.length === 3 ? 'active' : ''}`}>{code[3] || '_'}</div>
                <div className={`code ${code.length >= 5 ? 'valued' : ''} ${code.length === 4 ? 'active' : ''}`}>{code[4] || '_'}</div>
                <div className={`code ${code.length >= 6 ? 'valued' : ''} ${code.length >= 5 ? 'active' : ''}`}>{code[5] || '_'}</div>
            </div>
        </div>
    )
}